<template>
  <div id="toptables-tavolos-widget">
    <button id="toptables-tavolos-book-now" v-on:click="displayTavolosWidget = true">Book with BK</button>
    <div v-if="displayTavolosWidget === true" class="toptables-content">
      <transition name="tavolos-slide-right-fade" mode="out-in">
        <Book :restaurant_id="restaurant_id" :publisher_id="publisher_id"></Book>
      </transition>
    </div>
  </div>
</template>

<script>

  import Book from './Book.vue'

  export default {
    components: {
      Book
    },

    data () {
      return {
        displayTavolosWidget: false,
      }
    },
    props: [
      'restaurant_id',
      'publisher_id'
    ],
  }
</script>

<style lang="scss">
  #toptables-tavolos-widget {
    position: relative;
    max-width: 260px;
    width: auto;
    margin: auto;
    text-align: center;
    .flex,
    .flex.xs12,
    .flex.sm6 {
      width: 100% !important;
      max-width: 100% !important;
      flex-basis: 100% !important;
      margin: 0 !important;
    }
    #toptables-tavolos-book-now {
      margin: 0;
      font-size: inherit;
      font-weight: inherit;
      padding: 1em 3em;
      background: #000;
      border-radius: 30px;
      color: #fff;
      margin-bottom: 2em;
      outline: none;
      transition: 0.1s;
      font-weight: bold;
      &:hover, &:focus {
        background: #555;
      }
    }
    #tavolos-widget {
      .menu__content {
        min-width: 290px !important;
        max-width: 400px !important;
        overflow: auto;
        &.tavolos-block-people {
          top: 92px !important;
          left: 0 !important;
        }
        &.tavolos-block-date {
          top: 168px !important;
          left: 0 !important;
        }
        &.tavolos-block-time {
          top: 248px !important;
          left: 0 !important;
        }
      }
    }
  }

  @media (min-width: 600px) {
    #toptables-tavolos-widget {
      #tavolos-widget {
        .menu__content {
          &.tavolos-block-people {
            top: 92px !important;
            left: 0 !important;
          }
          &.tavolos-block-date {
            top: 168px !important;
            left: 0 !important;
          }
          &.tavolos-block-time {
            top: 248px !important;
            left: 0 !important;
          }
        }
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/components/TopTables.vue